import { render, staticRenderFns } from "./excess-info.vue?vue&type=template&id=13b88a56&"
import script from "./excess-info.vue?vue&type=script&lang=js&"
export * from "./excess-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports